export enum PublishingMedium {
  Print = 'print',
  Online = 'online',
  EEdition = 'e-edition'
}
